'use strict';

angular.module('cgmemApp')
	.controller('AdminCheckinsCtrl', function ($rootScope, $scope, $http, $log, AppConfig) {

		$scope.itemCountOpts = [{ label: "10/page", count: 10 }, { label: "20/page", count: 20 },
								{ label: "100/page", count: 100 }, { label: "1000/page", count: 1000 }];

		$scope.itemFilterOpts = [{ label: "Exceptions", val: false }, { label: "All", val: true }];

		$scope.currentPage = 1;
		$scope.pageSize = 20;

		var checkins = [];
		$scope.filtered = $scope.paged = [];
		$scope.all = true;
		$scope.epoch = null;
		
		AppConfig.get()
			.then(function(a) {
				$scope.season = a.season;
			})

		$scope.$watchGroup(['currentPage', 'pageSize', 'all', 'epoch'], function () {
			var start = ($scope.currentPage - 1) * $scope.pageSize;
			$scope.filtered = _.filter(checkins, function(c) {
				return !c.sMS || $scope.all;
			});
			$scope.paged = _.slice($scope.filtered, start, start + $scope.pageSize);
		});

		var getCheckins = function() {
			$http.get('/api/checkins')
				.then(function (r) {
					checkins = r.data;
					$scope.epoch = new Date();
				})
				.catch(function(err) {
					$rootScope.$emit('generalAlert', 'Error getting checkins:', err);
				});
		};


		$scope.$on('socket:checkedIn', function(ev, newCI) {
			checkins.unshift(newCI);
			$scope.epoch = new Date();
			//getCheckins();
		});
		$scope.$on('socket:checkedOut', function(ev, updatedCI) {
			let r = checkins.find(c => c._id === updatedCI._id);
			if(r) {
				r.checkOutDate = updatedCI.checkOutDate;
				$scope.epoch = new Date();
				$log.log('updated')
			}
			//getCheckins();
		});
		getCheckins();

	});
